import React, { useEffect, useState } from "react";
import profileBanner from '../../Assets/images/profile-bnr.webp'
import brandImg from "../../Assets/images/pro-img-2.png";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { CurrencyConvert, CurrencyConvertHistory, CurrencyIcon, decodeID, getDate, GethistoryPrices, getPriceHelper, GetPrices } from "../../utils/Helper";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import FrontLoader from "../layout/FrontLoader";
import { ApiTypes } from "../../constants/Constants";
import { LanguageConstants } from "../../constants/LanguageConstants";

function QutationHistory() {
    const [currency, setCurrency] = useState('USD')
    const { id } = useParams()
    const quotationHistory = useMakeRequest()
    const currencyGet = useMakeRequest()
    const [data, setData] = useState<any>({})
    const [buttonshow, setButtonShow] = useState(true)
  const GrandTotal = (e:any)=>{
        if(e){
        const quantity = e?.new_quantity ? e?.new_quantity : e?.quantity
        const shippingPrice = quantity  * e?.per_product_price;
        const total = Number(shippingPrice) 
        return total?.toFixed(2)
        }
    }

    useEffect(() => {
        const payload = {
            quotation_id: decodeID(id)
        }
        quotationHistory.makeRequest({ payload, url: ApiConstants?.QuotesHistory, toastStatus: false })
    }, [])

    useEffect(() => {
        if (quotationHistory?.data?.data) {
            setData(quotationHistory?.data?.data)
        }

    }, [quotationHistory?.data?.data])



    const getHistoryTaxValue = (e: any) => {
        if (e?.total_tax && e?.total_amount) {
            const total = Number(e?.total_shipping_amount) + Number(e?.total_product_amount) + Number(e?.other_charges)
            const taxValue = (total * e?.total_tax) / 100;
            return `${taxValue.toFixed(2)}`;
        } else {
            return '0.00';
        }
    };



    return (
        <>
            {quotationHistory.loading ? <FrontLoader /> : null}
            {/* main part */}
            <main>

                {/* top banner section start */}
                <section className="main-banner small-banner" style={{ background: `url(${profileBanner}) center/cover` }}>
                    <div className="container">
                        <h1 className="small-banner-heading">{LanguageConstants?.PRODUCT_HISTORY}</h1>
                        <nav className="com-breadcrumb" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/profile">{LanguageConstants?.PROFILE}</Link></li>
                                <li className="breadcrumb-item"><Link to="/my-quotation">{LanguageConstants?.MYQUOTATIONS}</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">View</li>
                            </ol>
                        </nav>
                    </div>
                </section>
                {/* top banner section end  */}

                <div className="container footer-space">

                    <div className="quote-ttl-price">
                        <div className="quote-ttl-price-left d-block">
                            <div className="non-edit-data">
                            <div className="quote-ttl me-3 me-sm-5">{LanguageConstants?.QUOTATIONID}</div>
                            <label className="non-edit-label">{data?.latestRequest?.quotation_id}</label>
                           </div>
                        </div>
                        <div className="quote-ttl-price-left d-block">
                            <div className="non-edit-data">
                            <div className="quote-ttl me-3 me-sm-5">{LanguageConstants?.REVISION} {LanguageConstants?.DATE}</div>
                            <label className="non-edit-label">{getDate(data?.latestRequest?.created_at)}</label>
                           </div>
                        </div>
                        {/* <span className="quote-bnr-tag ms-auto">In Progress</span> */}
                    </div>

                    <div className="quote-card-box">
                        <div className="quote-head">
                            <div className="row w-100 gy-3">
                                <div className="col-sm-6 col-lg-4">
                                    <div className="non-edit-data">
                                        <label className="non-edit-label fw-500">{LanguageConstants?.DELADDRESS}</label>
                                        <div className="non-edit-ct">{`${data?.latestRequest?.street_line} `}</div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-lg-4">
                                    <div className="non-edit-data">
                                        <label className="non-edit-label fw-500">{LanguageConstants?.SHIPINNG}</label>
                                        <div className="non-edit-ct">{data?.latestRequest?.shipping_Trans_detail?.name}</div>
                                    </div>
                                </div>
                                {/* <div className="form-check form-switch"> */}

                                <div className="col-sm-6 col-lg-4">
                                    <div className="form-check form-switch ps-0">
                                        <label className="form-check-label m-0 fs-6" style={{color: '#5A32C7'}}>{LanguageConstants?.CONVERTINPISO}</label>
                                        <input className="form-check-input ms-4" type="checkbox" defaultChecked={currency == "PHP" ? true : false}  onClick={()=>setCurrency( currency == "PHP" ? "USD" : 'PHP')}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h2 className="title-1 mb-3 mt-4">{LanguageConstants?.PRODUCT_REVISON_HISTORY}</h2>

                    <div className="accordion pro-history-accordion" id="accordionProHistory">
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <div className="accordion-ttl"><div className="accordion-ttl-txt">{LanguageConstants?.LATEST_REVISION}</div> <span className="accordion-ttl-date">{getDate(data?.latestRequest?.updated_at)}</span></div>
                                    {/* <span className="quote-bnr-tag ms-auto me-3">Pending</span>
                             */}
                                    {data?.latestRequest?.status == '0' ? <span className="quote-bnr-tag ms-auto">{LanguageConstants?.PENDING}</span> : data?.latestRequest?.status == '1' ? <span className="quote-bnr-tag ms-auto">{LanguageConstants?.Progress}</span> : data?.latestRequest?.status == '2' ? <span className="quote-bnr-tag ms-auto">{LanguageConstants?.APPROVED}</span> : <span className="quote-bnr-tag ms-auto">{LanguageConstants?.REJECT}</span>}
                                    <i className="icon-chev-btm ms-2"></i>
                                </button>
                            </h2>
                            <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionProHistory">
                                <div className="accordion-body">
                                    <div className="table-responsive">
                                    <div className="table-responsive com-table rqst-table rqst-table-view">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th className="text-center">{LanguageConstants?.Item}</th>
                                                    <th className="text-center">{LanguageConstants?.ORDER_QTY}</th>
                                                    <th className="text-center">{LanguageConstants?.BRAND}</th>
                                                    <th className="text-center">{LanguageConstants?.PARTNAME}</th>
                                                    <th className="text-center">{LanguageConstants?.Description}</th>
                                                    <th className="text-center">{LanguageConstants?.SERIALNUMBER}</th>
                                                    <th className="text-center">{LanguageConstants?.MODELNUMBER}</th>
                                                    <th className="text-center">{LanguageConstants?.PRE_PRODUCT_PRICE}</th>
                                                    <th className="text-center">{LanguageConstants?.EXTED_PRICE}</th>
                                                    {/* <th className="text-center">ETA</th> */}
                                                </tr>
                                            </thead>
    
                                            <tbody>
                                                {data?.latestRequest?.quotes_detail?.map((res: any, i: any) => (
    
                                                    <tr>
                                                        <td className="text-center">{i+1} <br/> </td>
                                                        <td className="text-center">{res?.new_quantity ? res?.new_quantity : res?.quantity} <br/> </td>
                                                        {res?.is_other_brand == "1" ?
                                                            <td className="text-center"> {res?.other_brand_name}</td>
                                                            :
                                                            <td className="text-center">{res?.brand_detail?.name}</td>
                                                        }
                                                        <td className="text-center">{res?.part_number}</td>
                                                        {res?.description ?<td className="text-center">{res?.description}</td>: <td className="text-center">N/A</td>}
                                                        {res?.serial_number ? <td className="text-center">{res?.serial_number}</td> : <td className="text-center">N/A</td>}
                                                        {res?.model_number ? <td className="text-center">{res?.model_number}</td> : <td className="text-center">N/A</td>}
                                                        <td className="text-center">{CurrencyIcon(currency)}{(res?.per_product_price) ?  getPriceHelper(CurrencyConvertHistory(res?.per_product_price, currency)) : '0.00'}</td>
                                                        {/* {res?.eta_day ? <td className="text-center">{res?.eta_day}</td> : <td className="text-center">N/A</td>} */}
                                                        <td className="text-center"> {CurrencyIcon(currency)}{( res?.eta_day) ?  getPriceHelper(CurrencyConvertHistory(GrandTotal(res) , currency)) :'0.00'} </td>
                                                        {/* <td className="text-center"> {res?.eta_day ? res?.eta_day : null} </td> */}
                                                        
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>             
                                    </div>

                                    <h2 className="title-1 my-3">{LanguageConstants?.PROVIDEDQUOTATION}</h2>

                                    <div className="table-responsive">
                                        <table className="table pro-history-table-2">
                                            <tbody>
                                                <tr>
                                                    <td>{LanguageConstants?.TOTAL_PRODUCT_PRICE}</td>
                                                    <td>{CurrencyIcon(currency)}{getPriceHelper(CurrencyConvertHistory(GetPrices(data?.latestRequest)?.productamount ? (GetPrices(data?.latestRequest)?.productamount) : '0', currency))} </td>
                                                </tr>
                                                <tr>
                                                    <td>{LanguageConstants?.TOTALSHIIPNGAMOUNT}</td>
                                                    <td>{CurrencyIcon(currency)}{getPriceHelper(CurrencyConvertHistory(GetPrices(data?.latestRequest)?.shippingamount ? GetPrices(data?.latestRequest)?.shippingamount : '0', currency))} </td>
                                                </tr>
                                                <tr>
                                                    <td>{LanguageConstants?.OTHER_CARGERS}</td>
                                                    <td>{CurrencyIcon(currency)}{getPriceHelper(CurrencyConvertHistory(data?.latestRequest?.other_charges, currency))} </td>

                                                </tr>
                                                <tr>
                                                    <td>{LanguageConstants?.TOTALTAX}</td>
                                                    <td>{CurrencyIcon(currency)}{getPriceHelper(CurrencyConvertHistory(GetPrices(data?.latestRequest)?.total_tax ? GetPrices(data?.latestRequest)?.total_tax : '0', currency))} </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td>{LanguageConstants?.GRANDTOTAL}</td>
                                                    <td>{CurrencyIcon(currency)}{getPriceHelper(CurrencyConvertHistory(GetPrices(data?.latestRequest)?.totalAmount ? GetPrices(data?.latestRequest)?.totalAmount : '0', currency))}</td>
                                                </tr>
                                                <p style={{ color: 'red' }}>{LanguageConstants?.PRIZEMESSAGE}</p>
                                                
                                            </tfoot>
                                        </table>
                                    </div>
                                    <div className="form-check form-switch">
                                        {/* <label className="form-check-label">Convert Price in Peso</label> */}
                                        {/* <input className="form-check-input" type="checkbox" defaultChecked={currency == "PHP" ? true : false}  onClick={()=>setCurrency( currency == "PHP" ? "USD" : 'PHP')}/> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {data?.HistoryRequest?.map((res: any, i: any) => (
                            <div key={i} >
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseTwo${i}`} aria-expanded="false" aria-controls={`collapseTwo${i}`}>
                                            <div className="accordion-ttl"><div className="accordion-ttl-txt">{LanguageConstants?.REVISION} {i + 1}</div> <span className="accordion-ttl-date">{getDate(res?.created_at)}</span></div>
                                            {res.status == '0' ? <span className="quote-bnr-tag ms-auto">{LanguageConstants?.PENDING}</span> : res.status == '1' ? <span className="quote-bnr-tag ms-auto">{LanguageConstants?.APPROVED}</span> : <span className="quote-bnr-tag ms-auto">{LanguageConstants?.REJECT}</span>}
                                            <i className="icon-chev-btm ms-2"></i>
                                        </button>
                                    </h2>
                                    <div id={`collapseTwo${i}`} className="accordion-collapse collapse" data-bs-parent="#accordionProHistory">
                                        <div className="accordion-body">
                                            <div className="table-responsive">
                                                 <div className="table-responsive com-table rqst-table rqst-table-view">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th className="text-center">{LanguageConstants?.Item}</th>
                                                    <th className="text-center">{LanguageConstants?.ORDER_QTY}</th>
                                                    <th className="text-center">{LanguageConstants?.NEW_QTY}</th>
                                                    <th className="text-center">{LanguageConstants?.BRAND}</th>
                                                    <th className="text-center">{LanguageConstants?.PARTNAME}</th>
                                                    {/* <th className="text-center">{LanguageConstants?.Description}</th> */}
                                                    <th className="text-center">{LanguageConstants?.SERIALNUMBER}</th>
                                                    <th className="text-center">{LanguageConstants?.MODELNUMBER}</th>
                                                    <th className="text-center">{LanguageConstants?.PRE_PRODUCT_PRICE}</th>
                                                    <th className="text-center">{LanguageConstants?.EXTED_PRICE}</th>
                                                    {/* <th className="text-center">ETA</th> */}
                                                </tr>
                                            </thead>
    
                                            <tbody>
                                                {res?.history_detail?.map((res: any, i: any) => (
     
                                                    <tr>
                                                        <td className="text-center">{i+1} <br/> </td>
                                                        <td className="text-center">{res?.quantity} <br/> </td>
                                                        <td className="text-center">{res?.new_quantity ? res?.new_quantity : res?.quantity} <br/> </td>

                                                        {res?.is_other_brand == "1" ?
                                                            <td className="text-center"> {res?.other_brand_name}</td>
                                                            :
                                                            <td className="text-center">{res?.brand_details?.name}</td>
                                                        }
                                                        <td className="text-center">{res?.part_number}</td>
                                                        {/* {res?.description ?<td className="text-center">{res?.description}</td>: <td className="text-center">N/A</td>} */}
                                                        {res?.serial_number ? <td className="text-center">{res?.serial_number}</td> : <td className="text-center">N/A</td>}
                                                        {res?.model_number ? <td className="text-center">{res?.model_number}</td> : <td className="text-center">N/A</td>}
                                                        <td className="text-center">{CurrencyIcon(currency)}{(res?.per_product_price) ?  getPriceHelper(CurrencyConvertHistory(res?.per_product_price, currency)) : '0.00'}</td>
                                                        {/* {res?.eta_day ? <td className="text-center">{res?.eta_day}</td> : <td className="text-center">N/A</td>} */}
                                                        <td className="text-center">{CurrencyIcon(currency)}{getPriceHelper(CurrencyConvertHistory(GrandTotal(res) , currency)) } </td>
                                                        {/* <td className="text-center"> {res?.eta_day ? res?.eta_day : null} </td> */}
                                                        
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>   
                                            </div>

                                            <h2 className="title-1 my-3">{LanguageConstants?.PROVIDEDQUOTATION}</h2>

                                            <div className="table-responsive">
                                                <table className="table pro-history-table-2">
                                                    <tbody>
                                                        <tr>
                                                            <td>{LanguageConstants?.TOTAL_PRODUCT_PRICE}</td>
                                                            <td>{CurrencyIcon(currency)}{getPriceHelper(CurrencyConvertHistory(GethistoryPrices(res?.history_detail)?.productamount ? GethistoryPrices(res?.history_detail)?.productamount : '0', currency))} </td>
                                                        </tr>
                                                        <tr>
                                                            <td>{LanguageConstants?.TOTAL_SHPPINGH}</td>
                                                            <td>{CurrencyIcon(currency)}{getPriceHelper(CurrencyConvertHistory(GethistoryPrices(res?.history_detail)?.shippingamount ? GethistoryPrices(res?.history_detail)?.shippingamount : '0', currency))} </td>
                                                        </tr>
                                                        <tr>
                                                            <td>{LanguageConstants?.OTHER_CARGERS}</td>
                                                            <td>{CurrencyIcon(currency)}{getPriceHelper(CurrencyConvertHistory(res?.history_detail[0]?.other_charges, currency))} </td>
                                                        </tr>
                                                        <tr>
                                                            <td>{LanguageConstants?.TOTALTAX}</td>
                                                            <td>{CurrencyIcon(currency)}{getPriceHelper(CurrencyConvertHistory(GethistoryPrices(res?.history_detail)?.total_tax ? GethistoryPrices(res?.history_detail)?.total_tax : '0', currency))} </td>
                                                        </tr>
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td>{LanguageConstants?.GRANDTOTAL}</td>
                                                            <td>{CurrencyIcon(currency)}{getPriceHelper(CurrencyConvertHistory(GethistoryPrices(res?.history_detail)?.totalAmount ? GethistoryPrices(res?.history_detail)?.totalAmount : '0', currency))} </td>
                                                        </tr>
                                                                                                                        <p style={{ color: 'red' }}>{LanguageConstants?.PRIZEMESSAGE}</p>
                                                        
                                                    </tfoot>
                                                </table>
                                            </div>
                                            <div className="form-check form-switch">
                                                {/* <label className="form-check-label">Convert Price in Peso</label> */}
                                                {/* <input className="form-check-input" type="checkbox"/> */}
                                                {/* <input className="form-check-input" type="checkbox" defaultChecked={currency == "PHP" ? true : false}  onClick={()=>setCurrency( currency == "PHP" ? "USD" : 'PHP')}/> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <div className="accordion-ttl"><div className="accordion-ttl-txt">{LanguageConstants?.ORIGNAL_REQUEST}</div> <span className="accordion-ttl-date">{getDate(data?.latestRequest?.created_at)}</span></div> <i className="icon-chev-btm ms-2 ms-auto"></i>
                                </button>
                            </h2>
                            <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionProHistory">
                                <div className="accordion-body">
                                    <div className="table-responsive">
                                <div className="table-responsive com-table rqst-table rqst-table-view">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th className="text-center">{LanguageConstants?.Item}</th>
                                                    <th className="text-center">{LanguageConstants?.ORDER_QTY}</th>
                                                    <th className="text-center">{LanguageConstants?.BRAND}</th>
                                                    <th className="text-center">{LanguageConstants?.PARTNAME}</th>
                                                    {/* <th className="text-center">{LanguageConstants?.Description}</th> */}
                                                    <th className="text-center">{LanguageConstants?.SERIALNUMBER}</th>
                                                    <th className="text-center">{LanguageConstants?.MODELNUMBER}</th>
                                                    <th className="text-center">{LanguageConstants?.PRE_PRODUCT_PRICE}</th>
                                                    <th className="text-center">{LanguageConstants?.EXTED_PRICE}</th>
                                                    {/* <th className="text-center">ETA</th> */}
                                                </tr>
                                            </thead>
    
                                            <tbody>
                                                {data?.originalRequest?.map((res: any, i: any) => (
                                                    <tr>
                                                        <td className="text-center">{i+1} <br/> </td>
                                                        <td className="text-center">{res?.quantity} <br/> </td>

                                                        {res?.is_other_brand == "1" ?
                                                            <td className="text-center"> {res?.other_brand_name}</td>
                                                            :
                                                            <td className="text-center">{res?.brand_details?.name}</td>
                                                        }
                                                        <td className="text-center">{res?.part_number}</td>
                                                        {/* {res?.description ?<td className="text-center">{res?.description}</td>: <td className="text-center">N/A</td>} */}
                                                        {res?.serial_number ? <td className="text-center">{res?.serial_number}</td> : <td className="text-center">N/A</td>}
                                                        {res?.model_number ? <td className="text-center">{res?.model_number}</td> : <td className="text-center">N/A</td>}
                                                        <td className="text-center">{CurrencyIcon(currency)}{(res?.per_product_price) ?  getPriceHelper(CurrencyConvertHistory(res?.per_product_price, currency)) : '0.00'}</td>
                                                        {/* {res?.eta_day ? <td className="text-center">{res?.eta_day}</td> : <td className="text-center">N/A</td>} */}
                                                        <td className="text-center">{CurrencyIcon(currency)}{getPriceHelper(CurrencyConvertHistory(GrandTotal(res) , currency)) } </td>
                                                        {/* <td className="text-center"> {res?.eta_day ? res?.eta_day : null} </td> */}
                                                        
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        </div>
                                    </div>
                                    <h2 className="title-1 my-3">{LanguageConstants?.PROVIDEDQUOTATION}</h2>
                                    <div className="table-responsive">
                                        <table className="table pro-history-table-2">
                                            <tbody>
                                                <tr>
                                                    <td>{LanguageConstants?.TOTAL_PRODUCT_PRICE}</td>
                                                    <td>{CurrencyIcon(currency)}{data?.originalRequest?.length > 0 ? getPriceHelper(CurrencyConvertHistory((data?.originalRequest[0]?.total_product_amount), currency)) : 0} </td>
                                                </tr>
                                                <tr>
                                                    <td>{LanguageConstants?.TOTALSHIIPNGAMOUNT}</td>
                                                    <td>{CurrencyIcon(currency)}{data?.originalRequest?.length > 0 ? getPriceHelper(CurrencyConvertHistory(data?.originalRequest[0]?.total_shipping_amount, currency)) : 0} </td>
                                                </tr>
                                                <tr>
                                                    <td>{LanguageConstants?.OTHER_CARGERS}</td>
                                                    <td>{CurrencyIcon(currency)}{data?.originalRequest?.length > 0 ? getPriceHelper(CurrencyConvertHistory(data?.originalRequest[0]?.other_charges, currency)) : null}</td>

                                                </tr>
                                                <tr>
                                                    <td>{LanguageConstants?.TOTALTAX}</td>
                                                    <td>{CurrencyIcon(currency)}{data?.originalRequest?.length > 0 ? getPriceHelper(CurrencyConvertHistory(getHistoryTaxValue(data?.originalRequest[0]), currency)) : null} </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td>{LanguageConstants?.GRANDTOTAL}</td>
                                                    <td>{CurrencyIcon(currency)}{data?.originalRequest?.length > 0 ? getPriceHelper(CurrencyConvertHistory(data?.originalRequest[0]?.total_amount, currency)) : null}</td>
                                                </tr>
                                                                                                                <p style={{ color: 'red' }}>{LanguageConstants?.PRIZEMESSAGE}</p>
                                                
                                            </tfoot>
                                        </table>
                                    </div>
                                  
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


            </main>
        </>
    )
}

export default QutationHistory